<template>
    <!--流程审核档案主页面-->
    <el-container>
        <el-aside class="aside-classify-tree">
            <div class="title">
                <div class="tag"></div>
                <span class="content">{{ $t('workFlowProcessAudit.AUDIT_FILE_LIST') }}</span>
            </div>
            <!--档案类名树-->
            <div class="fileTree">
                <td-tree
                    ref="TdTree"
                    :refreshIconShow="false"
                    :inputShow="true"
                    :lazyloading="true"
                    :draggable="false"
                    :calInternal="true"
                    :isClick="true"
                    :imgloading="true"
                    :checkStrictly="false"
                    @onClick="clickTreeNode"
                    :firstChecked="true"
                    :defaultKey="defaultExpandKey"
                    :showBox="false"
                    :isPaging="true"
                    :defaultProps="defaultProps"
                    nodeKey="id"
                    :interfaceName="interfaceName"
                    :params="initTreeParams"
                >
                </td-tree>
            </div>
        </el-aside>
        <el-container>
            <el-header>
                <div class="title">
                    <div class="tag"></div>
                    <div class="pathInfo">
                        <div class="pathPart" v-for="(item, index) in pathInfo" :key="index">
                            <i class="separator" v-show="index !== 0"> > </i>
                            <i v-show="index === 1 && pathHiddenFlag"> ... > </i>
                            <span>{{ item }}</span>
                        </div>
                    </div>
                </div>
                <div class="form">
                    <!--选中树形节点为档案目录时展示的form表单-->
                    <el-form inline="true" v-show="nodeTypeFlag" :model="fileListForm">
                        <el-form-item :label="$t('common.NAME')">
                            <td-input v-model="fileListForm.sName"></td-input>
                        </el-form-item>
                        <el-form-item>
                            <td-button type="primary" @click="queryFileListTable()">{{ $t('common.QUERY') }}</td-button>
                            <td-button @click="addTreeNode">{{ $t('common.ADD') }}</td-button>
                        </el-form-item>
                    </el-form>
                    <!--选中树形节点为档案时展示的form表单-->
                    <el-form inline="true" v-show="!nodeTypeFlag" labelWidth="80px" :model="fileForm">
                        <!--扩展元素数量大于6-->
                        <div v-show="Array.isArray(auditRelateInfo) && auditRelateInfo.length > 6" style="max-height: 100px;overflow-y: auto;padding: 2px 0;">
                            <el-form-item :label="$t('common.USERNAME')">
                                <td-input v-model="fileForm.sUserName"></td-input>
                            </el-form-item>
                            <el-form-item :label="$t('workFlowProcessAudit.ORG_STRUCT')">
                                <td-tree-select
                                    class="orgStructSelect"
                                    ref="tdOrgTree"
                                    nodeKey="id"
                                    :defaultProps="orgTree.defaultProps"
                                    :imgloading="true"
                                    :multiple="true"
                                    :interfaceName="orgTree.interfaceName"
                                    :calInternal="true"
                                    :lazyloading="true"
                                    v-model="fileForm.sOrgList"
                                    :width="300"
                                    :showBox="true"
                                    :expandOnClick="true"
                                ></td-tree-select>
                            </el-form-item>
                            <el-form-item v-for="item in auditRelateInfo" :key="item.sId" :label="item.sRemark">
                                <td-select v-model="item.value" :options="item.labelList" keys="sId" text="sRemark"></td-select>
                            </el-form-item>
                        </div>
                        <el-form-item v-show="!(Array.isArray(auditRelateInfo) && auditRelateInfo.length > 6)" :label="$t('common.USERNAME')">
                            <td-input v-model="fileForm.sUserName"></td-input>
                        </el-form-item>
                        <el-form-item v-show="!(Array.isArray(auditRelateInfo) && auditRelateInfo.length > 6)" :label="$t('workFlowProcessAudit.ORG_STRUCT')">
                            <td-tree-select
                                class="orgStructSelect"
                                ref="tdOrgTree"
                                nodeKey="id"
                                :defaultProps="orgTree.defaultProps"
                                :imgloading="true"
                                :multiple="true"
                                :interfaceName="orgTree.interfaceName"
                                :calInternal="true"
                                :lazyloading="true"
                                v-model="fileForm.sOrgList"
                                :width="300"
                                :showBox="true"
                                :expandOnClick="true"
                            ></td-tree-select>
                        </el-form-item>
                        <el-form-item v-show="!(Array.isArray(auditRelateInfo) && auditRelateInfo.length > 6)" v-for="item in auditRelateInfo" :key="item.sId" :label="item.sRemark">
                            <td-select v-model="item.value" :options="item.labelList" keys="sId" text="sRemark"></td-select>
                        </el-form-item>
                        <el-form-item>
                            <td-button type="primary" @click="queryFileInfo">{{ $t('common.QUERY') }}</td-button>
                            <td-button @click="addFile">{{ $t('common.ADD') }}</td-button>
                            <td-button @click="batchDeleteFile">{{ $t('common.DELETE_BATCH') }}</td-button>
                            <td-button @click="templateUpload">{{ $t('workFlowProcessAudit.TEMPLATE_UPLOAD') }}</td-button>
                            <td-button @click="fileInfoImport">{{ $t('common.IMPORT') }}</td-button>
                            <td-button @click="exportFileInfo">{{ $t('common.EXPORT') }}</td-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-header>
            <el-main>
                <!--档案目录信息表-->
                <td-table
                    v-show="nodeTypeFlag"
                    :hasMutiSelect="false"
                    :columns="fileListTable.columns"
                    :dataSource="fileListTable.data"
                    :pageSize="fileListTable.pageSize"
                    :currentPage="fileListTable.pageNum"
                    :total="fileListTable.totals"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentPageChange"
                >
                </td-table>
                <!--档案信息表-->
                <td-table
                    class="auditInfoTable"
                    ref="fileTable"
                    v-show="!nodeTypeFlag"
                    :key="fileTable.columns"
                    height="550px"
                    :hasMutiSelect="true"
                    :columns="fileTable.columns"
                    :dataSource="fileTable.data"
                    :pageSize="fileTable.pageSize"
                    :currentPage="fileTable.pageNum"
                    :total="fileTable.totals"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentPageChange"
                ></td-table>
            </el-main>
        </el-container>
        <!--添加/编辑档案目录弹窗-->
        <add-or-update-tree-node
            v-if="editTreeNodeDialog.visible"
            :dialogVisible="editTreeNodeDialog.visible"
            :title="editTreeNodeDialog.title"
            :operateFlag="editTreeNodeDialog.operateFlag"
            :data="editTreeNodeDialog.data"
            @queryFileListTable="queryFileListTable"
            @queryFileListTree="queryFileListTree"
            @dialogClose="editTreeNodeDialogClose"
        ></add-or-update-tree-node>
        <!--添加档案弹窗-->
        <add-file-dialog
            v-if="addFileDialog.visible"
            :dialogVisible="addFileDialog.visible"
            :data="addFileDialog.data"
            @dialogClose="addFileDialogClose"
            @queryFileInfo="queryFileInfo"
        ></add-file-dialog>
        <!--编辑档案弹窗-->
        <edit-file-dialog v-if="editFileDialog.visible" :dialogVisible="editFileDialog.visible" :data="editFileDialog.data" @dialogClose="editFileDialogClose"></edit-file-dialog>
        <!--导入档案弹窗-->
        <audit-file-import-dialog
            v-if="auditFileImportDialog.visible"
            :dialogVisible="auditFileImportDialog.visible"
            :data="auditFileImportDialog.data"
            @dialogClose="auditFileImportDialogClose"
            @refreshAuditInfo="queryFileInfo"
        ></audit-file-import-dialog>
    </el-container>
</template>

<script>
import Api from './assets/api';
import addOrUpdateTreeNode from './components/processAuditFileComponents/addOrUpdateTreeNode';
import addFileDialog from './components/processAuditFileComponents/addFileDialog';
import editFileDialog from './components/processAuditFileComponents/editFileDialog';
import auditFileImportDialog from './components/processAuditFileComponents/auditFileImportDialog';
export default {
    name: 'processAuditFile',
    components: { addOrUpdateTreeNode, addFileDialog, editFileDialog, auditFileImportDialog },
    data() {
        return {
            pathHiddenFlag: false, //路径隐藏标志
            //组织树参数
            orgTree: {
                defaultProps: {
                    parentId: 'parentId',
                    children: 'children',
                    id: 'id',
                    label: 'caption',
                    imgName: 'sIcon'
                },
                value: '',
                interfaceName: { query: '/OrgStructureController/findOrgStructureTree', search: '/OrgStructureController/findOrgStructureTree' }
            },
            initTreeParams: { parentId: '0001', pageNum: 1 }, //用于档案树形初始化
            nodeTypeFlag: true, //选中树形节点类型标识符，true:文件夹 false:审核档案 (form表单和table会根据选中节点类型变化而变化)
            defaultExpandKey: ['ef2e11a0-c0cb-484e-ba4c-9c0e35fd8401'], //默认展开树形节点id数组
            pathInfo: [this.$t('workFlowProcessAudit.PROCESS_AUDIT_FILE')], //路径信息
            defaultProps: { label: 'sName', id: 'id', children: 'children', imgName: 'sIcon', parentId: 'sParentId' },
            //添加/编辑档案类目节点弹窗
            editTreeNodeDialog: {
                operateFlag: '', //操作标识
                title: '', //弹窗标题
                visible: false, //弹窗开关
                data: null //传给子组件的参数
            },
            //打开档案信息弹窗
            addFileDialog: {
                visible: false, //添加档案弹窗控制开关
                data: {}
            },
            //编辑档案信息弹窗
            editFileDialog: {
                visible: false,
                data: {}
            },
            //导入档案信息弹框
            auditFileImportDialog: {
                visible: false,
                data: {}
            },
            //树形组件查询路由（query是懒加载接口路由，search是搜索框查询接口路由）
            interfaceName: { query: '/auditGroupManage/queryAuditTree', search: '/auditGroupManage/queryAuditNode' },
            fileListForm: { sName: '' }, //档案目录表单
            fileForm: {
                sUserName: '', //用户名
                sOrgList: '', //组织架构
                auditRelateVoList: []
            }, //档案表单
            //档案目录信息展示表
            fileListTable: {
                //表头属性
                columns: [
                    {
                        prop: 'sName',
                        label: this.$t('common.NAME'),
                        align: 'left',
                        showOverflowTooltip: 'true'
                    },
                    {
                        prop: 'iType',
                        label: this.$t('common.TYPE'),
                        align: 'center',
                        render: (createElement, params) => {
                            if (params.row.iType === 0) {
                                return createElement('span', this.$t('workFlowProcessAudit.FOLDER'));
                            } else if (params.row.iType === 1) {
                                return createElement('span', this.$t('workFlowProcessAudit.AUDIT_FILE'));
                            }
                        }
                    },
                    {
                        prop: 'sRemark',
                        label: this.$t('common.DESCRIPTION'),
                        align: 'left',
                        showOverflowTooltip: 'true'
                    },
                    {
                        prop: '',
                        label: 'pgCommon.OPERATE',
                        tableWidth: '250',
                        align: 'center',
                        render: (createElement, params) => {
                            let b1 = createElement(
                                'td-button',
                                {
                                    props: { type: 'text' },
                                    style: { 'min-width': '40px' },
                                    on: {
                                        click: () => {
                                            this.editTreeNode(params.row, false);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            );
                            let b2 = createElement(
                                'td-button',
                                {
                                    props: { type: 'text' },
                                    style: { 'min-width': '40px' },
                                    on: {
                                        click: () => {
                                            this.deleteTreeNode(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            );

                            let list = [b1, b2];
                            return createElement('div', list);
                        }
                    }
                ],
                data: [],
                pageSize: 10, //table表每页信息条数
                pageNum: 1, //table表当前页
                totals: '' //table表数据总条数
            },
            //扩展资源信息
            auditRelateInfo: [],
            //档案信息展示表
            fileTable: {
                //表头属性
                columns: [
                    {
                        prop: 'sUserName',
                        label: this.$t('common.USERNAME'),
                        align: 'center',
                        tableWidth: '150px',
                        showOverflowTooltip: 'true'
                    },
                    {
                        prop: 'sOrgName',
                        label: this.$t('workFlowProcessAudit.ORG_STRUCT'),
                        align: 'left',
                        showOverflowTooltip: 'true'
                    },
                    {
                        prop: '',
                        label: 'pgCommon.OPERATE',
                        tableWidth: '150',
                        align: 'center',
                        fixed: 'right',
                        render: (createElement, params) => {
                            let b1 = createElement(
                                'td-button',
                                {
                                    props: { type: 'text' },
                                    style: { 'min-width': '40px' },
                                    on: {
                                        click: () => {
                                            this.editFile(params.row, false);
                                        }
                                    }
                                },
                                this.$t('pgCommon.EDIT')
                            );
                            let b2 = createElement(
                                'td-button',
                                {
                                    props: { type: 'text' },
                                    style: { 'min-width': '40px' },
                                    on: {
                                        click: () => {
                                            this.deleteFile(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.DELETE')
                            );

                            let list = [b1, b2];
                            return createElement('div', list);
                        }
                    }
                ],
                data: [],
                pageSize: 10, //table表每页信息条数
                pageNum: 1, //table表当前页
                totals: '' //table表数据总条数
            }
        };
    },
    created() {},
    mounted() {
        setTimeout(() => {
            this.queryFileListTable();
        }, 500);
    },
    computed: {
        //当前选中树形节点
        currentTreeNode() {
            return this.$refs.TdTree.getCurrentNode();
        }
    },
    methods: {
        //获取当前路径
        getCurrentPath() {
            this.pathInfo = [this.$t('workFlowProcessAudit.PROCESS_AUDIT_FILE')];
            //获取树形数据结构
            let treeData = this.$refs.TdTree.lazyTreeData[0].children;
            //获取选中节点信息
            let currentNode = this.currentTreeNode;
            //将选中节点路径信息转化为数组,例：'001-002-003'指一级目录iOrder为1，二级目录iOrder为2，三级目录iOrder为3的路径信息
            let pathArray = currentNode.sPath.split('-');
            let level = currentNode.iLevel;
            level > 5 ? (this.pathHiddenFlag = true) : (this.pathHiddenFlag = false); //根据路径深度判断是否隐藏部分路径
            //除去root节点,从第二级目录开始遍历获取每级的路径名称
            for (let i = 1; i <= level; i++) {
                treeData.some((item, index) => {
                    if (item.iOrder == pathArray[i]) {
                        if (i >= level - 5) {
                            this.pathInfo.push(item.sName);
                        }
                        treeData = treeData[index].children;
                        return true;
                    }
                });
            }
        },
        //查询档案类目树
        queryFileListTree() {
            // let params = { parentId: this.currentTreeNode.id };
            // this.$refs.TdTree.queryData(params);
            this.$refs.TdTree.initTree(true, false);
        },
        //每页条数改变触发事件
        handleSizeChange(pageSize) {
            if (this.nodeTypeFlag) {
                this.fileListTable.pageSize = pageSize;
                this.queryFileListTable();
            } else {
                this.fileTable.pageSize = pageSize;
                this.queryFileInfo();
            }
        },
        //分页页码改变触发事件
        currentPageChange(currentPage) {
            if (this.nodeTypeFlag) {
                this.fileListTable.pageNum = currentPage;
                this.queryFileListTable();
            } else {
                this.fileTable.pageNum = currentPage;
                this.queryFileInfo();
            }
        },
        //查询选中档案文件夹对应的table信息 （只有在点击查询按钮时才会进行条件查询）
        queryFileListTable() {
            let params = { pageSize: this.fileListTable.pageSize, pageNum: this.fileListTable.pageNum };
            params.parentId = this.currentTreeNode.id;
            params.sName = this.fileListForm.sName;

            Api.queryFileListTable(params, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/auditGroupManage/queryAuditTree', response);
                    return;
                }
                if (response.data.statusCode === 'API-COMMON-INF-OK') {
                    this.fileListTable.data = response.data.content;
                    this.fileListTable.totals = response.data.count;
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.TABLE_REFRESH_FAIL') });
                }
            });
        },
        //判断树形节点类型
        decideNodeType(type) {
            if (type === 0) {
                this.nodeTypeFlag = true;
                let currentNode = this.currentTreeNode;
                this.fileListTable.data = currentNode.children;
            } else if (type === 1) {
                this.nodeTypeFlag = false;
            }
        },
        // 点击树形节点触发事件
        clickTreeNode(node) {
            this.decideNodeType(node.iType);
            //刷新table表展示信息
            if (this.nodeTypeFlag) {
                this.queryFileListTable();
            } else {
                this.getAuditRelateInfo();
                this.queryFileInfo();
            }
            //获取选中节点路径
            this.getCurrentPath();
        },
        //获取档案对应扩展资源信息
        getAuditRelateInfo() {
            let auditRelateInfo = this.currentTreeNode.auditGroupRelateVoList;
            let labelGroupIds = [];
            if (this.$util.isEmpty(auditRelateInfo)) {
                this.auditRelateInfo = [];
                this.getExpandColumns();
                return;
            } else {
                auditRelateInfo.forEach(item => {
                    labelGroupIds.push(item.sLabelGroupId);
                });
                let params = { needLabelInfo: true, needPage: false, idList: labelGroupIds };
                Api.searchLabelGroupByIds(params, response => {
                    if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                        this.$log.error('/workFlowLabelGroup/queryLabelGroup', response);
                        return;
                    }
                    if (response.data.statusCode === 'API-COMMON-INF-OK') {
                        this.auditRelateInfo = response.data.content;
                        this.getExpandColumns();
                    } else {
                        this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.TABLE_REFRESH_FAIL') });
                    }
                });
            }
        },
        //获取档案信息列表属性，用于table展示
        getExpandColumns() {
            let length = this.fileTable.columns.length;
            this.fileTable.columns.splice(2, length - 3);
            let object = {
                prop: '',
                label: '',
                align: 'center',
                minWidth: '200px',
                showOverflowTooltip: 'true'
            };
            this.auditRelateInfo.forEach((item, index) => {
                object.prop = item.sName;
                object.label = item.sRemark;
                try {
                    this.fileTable.columns.splice(index + 2, 0, JSON.parse(JSON.stringify(object)));
                } catch (e) {
                    console.log('Json conversion failed', e);
                }
            });
        },
        //展开树形节点
        expandNode() {},
        //打开添加档案类目弹框
        addTreeNode() {
            this.editTreeNodeDialog.operateFlag = 'add';
            this.editTreeNodeDialog.data = this.currentTreeNode;
            this.editTreeNodeDialog.title = this.$t('workFlowProcessAudit.ADD_NODE');
            this.editTreeNodeDialog.visible = true;
        },
        //打开编辑档案类目弹框
        editTreeNode(params) {
            this.editTreeNodeDialog.operateFlag = 'edit';
            this.editTreeNodeDialog.title = this.$t('workFlowProcessAudit.EDIT_NODE');
            this.editTreeNodeDialog.data = params;
            this.editTreeNodeDialog.visible = true;
        },
        //关闭添加/编辑档案目录节点的弹窗
        editTreeNodeDialogClose() {
            this.editTreeNodeDialog.visible = false;
        },
        //删除档案目录节点
        deleteTreeNode(node) {
            this.$confirm(this.$t('workFlowProcessAudit.CONFIRM_DELETE'), this.$t('pgCommon.TIPS'), {
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                confirmButtonText: this.$t('pgCommon.SURE'),
                type: 'warning'
            })
                .then(() => {
                    let param = { sId: node.id, sPath: node.sPath, iType: node.iType };
                    Api.deleteAuditNode(param, response => {
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$log.error('/auditGroupManage/deleteAuditNode', response);
                            return;
                        }
                        if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                            this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.DELETE_FAIL') });
                            this.$log.error('', response);
                            return;
                        }
                        this.queryFileListTable(); //刷新table信息
                        this.$refs.TdTree.queryData({ parentId: node.sParentId }); //刷新树形展示信息
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                    });
                })
                .catch(() => {
                    this.$log.error('');
                });
        },
        //打开添加档案弹窗
        addFile() {
            this.addFileDialog.visible = true;
            this.addFileDialog.data.auditRelateInfo = JSON.parse(JSON.stringify(this.auditRelateInfo));
            this.addFileDialog.data.currentTreeNode = JSON.parse(JSON.stringify(this.currentTreeNode));
        },
        //关闭添加档案弹窗
        addFileDialogClose() {
            this.addFileDialog.visible = false;
        },
        //打开编辑档案弹窗
        editFile(params) {
            this.editFileDialog.visible = true;
            this.editFileDialog.data = params;
            this.editFileDialog.data.expandResources = this.auditRelateInfo;
        },
        //关闭编辑档案弹窗
        editFileDialogClose() {
            this.queryFileInfo();
            this.editFileDialog.visible = false;
        },
        //删除档案
        deleteFile(data) {
            this.$confirm(this.$t('workFlowProcessAudit.CONFIRM_DELETE'), this.$t('pgCommon.TIPS'), {
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                confirmButtonText: this.$t('pgCommon.SURE'),
                type: 'warning'
            })
                .then(() => {
                    let param = [{ sId: data.sId }];
                    Api.deleteBatchFileInfo(JSON.stringify(param), response => {
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$log.error('/auditManage/deleteBatchAudit', response);
                            return;
                        }
                        if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                            this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.DELETE_FAIL') });
                            this.$log.error('', response);
                            return;
                        }
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                        this.queryFileInfo();
                    });
                })
                .catch(() => {
                    this.$log.error('');
                });
        },
        //通过labelGroupId和labelId获取prop和sRemark
        getRemark(sGroupId, labelId) {
            let obj = {};
            let auditRelateInfo = {};
            try {
                auditRelateInfo = JSON.parse(JSON.stringify(this.auditRelateInfo));
            } catch (e) {
                console.log('Json conversion failed', e);
            }
            auditRelateInfo.forEach(item => {
                if (item.sId === sGroupId) {
                    obj.prop = item.sName;
                    item.labelList.forEach(element => {
                        if (element.sId == labelId) {
                            obj.sRemark = element.sRemark;
                        }
                    });
                }
            });
            return obj;
        },
        //查询档案信息
        queryFileInfo() {
            let params = { pageSize: this.fileTable.pageSize, pageNum: this.fileTable.pageNum, sAuditGroupId: this.currentTreeNode.id };
            this.fileForm.auditRelateVoList = [];
            this.auditRelateInfo.forEach(item => {
                if (!this.$util.isEmpty(item.value)) {
                    this.fileForm.auditRelateVoList.push({ sLabelId: item.value });
                }
            });
            for (const key in this.fileForm) {
                params[key] = this.fileForm[key];
            }
            Api.queryFileInfo(params, response => {
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$log.error('/auditManage/queryAuditList', response);
                    return;
                }
                if (response.data.statusCode === 'API-COMMON-INF-OK') {
                    this.fileTable.data = response.data.content;
                    this.fileTable.totals = response.data.count;
                    //动态信息展示
                    this.fileTable.data.forEach(item => {
                        let auditRelateVoList = {};
                        try {
                            auditRelateVoList = JSON.parse(JSON.stringify(item.auditRelateVoList));
                        } catch (e) {
                            console.log('Json conversion failed', e);
                        }
                        auditRelateVoList.forEach(element => {
                            let obj = this.getRemark(element.sLabelGroupId, element.sLabelId);
                            item[obj.prop] = obj.sRemark;
                        });
                    });
                } else {
                    this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.TABLE_REFRESH_FAIL') });
                }
            });
        },
        //批量删除档案信息
        batchDeleteFile() {
            this.$confirm(this.$t('workFlowProcessAudit.CONFIRM_DELETE_CHECK_AUDIT'), this.$t('pgCommon.TIPS'), {
                cancelButtonText: this.$t('pgCommon.CANCEL'),
                confirmButtonText: this.$t('pgCommon.SURE'),
                type: 'warning'
            })
                .then(() => {
                    let param = [];
                    this.$refs.fileTable.multipleSelection.forEach(item => {
                        param.push({ sId: item.sId });
                    });
                    Api.deleteBatchFileInfo(param, response => {
                        if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                            this.$log.error('/auditManage/deleteBatchAudit', response);
                            return;
                        }
                        if (response.data.statusCode !== 'API-COMMON-INF-OK') {
                            this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.DELETE_FAIL') });
                            this.$log.error('', response);
                            return;
                        }
                        this.queryFileInfo(); //刷新table信息
                        this.$message({ type: 'success', showClose: true, message: this.$t('pgCommon.DELETE_SUCCESS') });
                    });
                })
                .catch(() => {
                    this.$log.error('');
                });
        },
        //文件流解码
        doDownload(response) {
            let blob = new Blob([response.data], { type: 'application/x-xls' });
            this.content = response.data;
            // 汉字解码
            let filename = decodeURIComponent(response.headers['filename']);
            if (window.navigator.msSaveOrOpenBlob) {
                // 兼容IE10
                window.navigator.msSaveBlob(blob, filename);
            } else {
                //  chrome/firefox
                let aTag = document.createElement('a');
                aTag.download = filename;
                aTag.href = window.URL.createObjectURL(blob);
                aTag.click();
                URL.revokeObjectURL(aTag.href);
            }
        },
        //模板下载
        templateUpload() {
            let params = { sAuditGroupId: this.currentTreeNode.id };
            let responseType = 'arraybuffer';
            Api.templateUpload(params, responseType, response => {
                let result = response.headers.result;
                if (result === 'success') {
                    this.doDownload(response);
                } else {
                    this.$log.error('/auditManage/importAuditTemplate', response);
                }
            });
        },
        //打开导入弹框
        fileInfoImport() {
            this.auditFileImportDialog.visible = true;
            this.auditFileImportDialog.data.sAuditGroupId = this.currentTreeNode.id;
        },
        //关闭导入弹框
        auditFileImportDialogClose() {
            this.auditFileImportDialog.visible = false;
        },
        //导出
        exportFileInfo() {
            let params = { sAuditGroupId: this.currentTreeNode.id };
            let responseType = 'arraybuffer';
            Api.exportAudit(params, responseType, response => {
                let result = response.headers.result;
                if (result === 'success') {
                    this.doDownload(response);
                } else {
                    this.$log.error('/auditManage/exportAudit', response);
                    if (response.data.statusCode === 'AUDIT_GROUP_LABEL_GROUP_NONE') {
                        this.$message({ type: 'warning', showClose: true, message: response.data.statusMessage });
                    }
                    console.log(String.fromCharCode.apply(null, new Uint16Array(response.data)));
                    this.$message({ type: 'error', showClose: true, message: this.$t('workFlowProcessAudit.EXPORT_FAIL') });
                }
            });
        }
    }
};
</script>

<style scoped>
.aside-classify-tree {
    padding-left: 20px;
}
/*.fileTree /deep/ .el-tree-node__content span {*/
/*    line-height: 36px;*/
/*}*/

.title {
    height: 20px;
    margin: 20px 10px 10px 0;
    display: flex;
}
.title > .tag {
    height: 16px;
    width: 3px;
    background: #10c0ff;
    margin: 3px 10px 0 0;
}
.title > .content {
    line-height: 20px;
}
.title > .pathInfo {
    display: flex;
    line-height: 20px;
}
.title .pathInfo .separator {
    padding-left: 5px;
}
.el-icon-arrow-down {
    padding-left: 2px;
}
.orgStructSelect >>> .el-popover__reference {
    width: 200px !important;
    height: 36px !important;
}
.auditInfoTable >>> .el-table__body tr.hover-row > td.el-table__cell {
    background-color: transparent;
}
</style>
